import React from 'react'
import Navbar from '../components/maketApp/site/Navbar'

import Footer from '../components/maketApp/site/Footer'
import About from '../components/maketApp/site/About'
import HerosAbout from '../components/maketApp/site/HerosAbout'

const Abouts = () => {
  return (
    <div>
       <Navbar />
       <HerosAbout />
       <About />
      

         <Footer />
    </div>
  )
}

export default Abouts
